<template>
    <dropdown-notification v-cloak>
        <div slot="fa-icon">
            <i class="fa fa-bell" aria-hidden="true"></i>
            <div id="alertas" class="badge-warning">{{ notificaciones.length }}</div>
        </div>
        <ul slot="content">
            <div class="notification__name">Notificaciones</div>
            <li v-for="(notificacion, index) in notificaciones" :key="index">
                <a href="#">
                    <span>{{ notificacion.descripcion }}</span>
                </a>
            </li>
        </ul>
    </dropdown-notification>
</template>

<script>
export default {
    data : function () {
        return {
            notificaciones : []
        };
    },
    methods : {
        cargarNotificaciones : function () {
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200 || this.status == 201) {
                    let json = JSON.parse(this.responseText);
                    that.notificaciones = json;
                }
            };
            xmlhttp.open("GET", url + '/notificaciones', true);
            xmlhttp.send();
        }
    },
    mounted : function () {
        this.cargarNotificaciones();
        let that = this;
        setInterval(function () {
            that.cargarNotificaciones();
        }, 60000);
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/Notificaciones.vue